import arrayLikeKeys from "./_arrayLikeKeys.js";
import baseKeysIn from "./_baseKeysIn.js";
import isArrayLike from "./isArrayLike.js";
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, !0) : baseKeysIn(object);
}
export {
  keysIn as default
};
//# sourceMappingURL=keysIn.js.map
